var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-skeleton',{staticClass:"mb-4",attrs:{"width":"250px","height":"40px"}}),_c('b-skeleton',{attrs:{"width":"100%","height":"18px"}}),_c('b-skeleton',{attrs:{"width":"100%","height":"18px"}}),_c('b-skeleton',{attrs:{"width":"75%","height":"18px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }